/** The fast filter of a real-time sky (`octmap_filter.glsl:94-217`), Godot's precomputed taps per layer. */
import { FAST_FILTER_COEFFICIENTS, } from '../../godot/rendering/environment/skyFastFilterCoefficients.js';
import { FAST_FILTER_CHAIN_SIZES } from '../../godot/rendering/environment/skyReflection.js';
import { LAYER_FILTER_UNIFORMS } from './layerFilter.js';
import { FAST_FILTER_FRAGMENT_SHADER } from './skyLayerShaders.js';
import { skyPass } from './skyPass.js';
import { perObject } from '../../utils/perObject.js';
/** Each level of Godot's table, its parts flattened as the shader's `vec4` arrays of the same names read them. */
const tapsByLevel = FAST_FILTER_COEFFICIENTS.map((level) => Object.fromEntries(Object.entries(level).map(([part, values]) => [part, Float32Array.from(values.flat())])));
const fastFilterPassFor = perObject(() => skyPass(FAST_FILTER_FRAGMENT_SHADER, [
    ...LAYER_FILTER_UNIFORMS,
    'frameX',
    'frameY',
    'frameZ',
    'lod',
    'weight',
]));
export const fastFilter = {
    chainSizes: FAST_FILTER_CHAIN_SIZES,
    passFor: fastFilterPassFor,
    /**
     * Layer `n` takes the table's level `n - 1`, as Godot filters layers 1 to 6 into its outputs 0 to
     * 5 (`sky.cpp:410-411`, `octmap_filter.glsl:80`).
     */
    layerUniforms(layer) {
        const taps = tapsByLevel[layer - 1];
        if (!taps)
            throw new Error(`expected a layer from 1 to ${tapsByLevel.length}, got ${layer}`);
        return taps;
    },
};
//# sourceMappingURL=fastFilter.js.map